import React from 'react'
import { AvailableLabel, Link, CtaArrow } from 'newComponents'
import classNames from 'classnames'
import './styles.scss'

const TaglineTitleContent = ({ tagline, title, content, badge, className, lightText, isHeader, fullWidthCentered, ctas }) => {
  // pass this component html content'

  const RenderTaglineTitle = () => {
    if (!fullWidthCentered) {
      return (
        <>
          {tagline && (
            <div className="tagline-title-content-header">
              <div className="tagline-title-content-tagline" dangerouslySetInnerHTML={{ __html: tagline }} />
              {badge && badge !== 'None' && <AvailableLabel badge={badge} lightText={lightText} />}
            </div>
          )}
          {title && <div className="tagline-title-content-title" dangerouslySetInnerHTML={{ __html: title }} />}
        </>
      )
    }
    return null
  }

  return (
    <div className={`tagline-title-content ${className || ''} ${isHeader ? 'is-header' : ''}`}>
      <RenderTaglineTitle />
      {content && (
        <div
          className={classNames('tagline-title-content-content', {
            'tagline-title-content-content-with-full-width-title': fullWidthCentered
          })}
          dangerouslySetInnerHTML={{ __html: content }}
        />
      )}

      {ctas && <Link className="tagline-title-cta" to={ctas.ctaUrl.url}>{ctas.ctaText.text} <CtaArrow /></Link>}
    </div>
  )
}
export default TaglineTitleContent
